export interface ServiceItem {
  id: string;
  name: string;
  category: string;
  price: number;
  originalPrice: number;
  duration: string;
  description: string;
  imageSeq: string;
}

export interface ServiceCategory {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const serviceCategories: ServiceCategory[] = [
  { id: 'all', name: '全部服务', slug: 'all', icon: 'ri-apps-line', description: '浏览所有沙龙服务项目' },
  { id: 'hair', name: '美发造型', slug: 'hair', icon: 'ri-scissors-line', description: '时尚发型设计与造型' },
  { id: 'makeup', name: '美妆体验', slug: 'makeup', icon: 'ri-brush-line', description: '精致妆容体验服务' },
  { id: 'skincare', name: '护肤管理', slug: 'skincare', icon: 'ri-magic-line', description: '专业护肤与面部管理' },
  { id: 'nails', name: '美甲艺术', slug: 'nails', icon: 'ri-paint-brush-line', description: '创意美甲设计与护理' },
  { id: 'packages', name: '优惠套餐', slug: 'packages', icon: 'ri-gift-line', description: '超值组合套餐推荐' },
];

export const services: ServiceItem[] = [
  {
    id: 'hair-1',
    name: '日系空气感剪发',
    category: 'hair',
    price: 68,
    originalPrice: 128,
    duration: '45分钟',
    description: '采用日系分层剪裁技术，打造轻盈蓬松的空气感发型，修饰脸型更显精致。含洗发与基础造型。',
    imageSeq: 'service-hair-01',
  },
  {
    id: 'hair-2',
    name: '韩式柔顺烫发',
    category: 'hair',
    price: 188,
    originalPrice: 328,
    duration: '120分钟',
    description: '韩国进口药水，温和不伤发。打造自然柔顺的波浪卷，提升整体气质。含烫前护理与烫后修复。',
    imageSeq: 'service-hair-02',
  },
  {
    id: 'hair-3',
    name: '潮色渐变染发',
    category: 'hair',
    price: 158,
    originalPrice: 288,
    duration: '90分钟',
    description: '采用植物配方染膏，低氨不刺激。从发根到发尾的渐变色彩，展现个性时尚。含染后锁色护理。',
    imageSeq: 'service-hair-03',
  },
  {
    id: 'hair-4',
    name: '柔顺直发护理',
    category: 'hair',
    price: 128,
    originalPrice: 228,
    duration: '60分钟',
    description: '深层滋养修复毛躁发质，使用角蛋白精华注入发丝，打造顺滑亮泽的直发效果。',
    imageSeq: 'service-hair-04',
  },
  {
    id: 'hair-5',
    name: '精致编发造型',
    category: 'hair',
    price: 48,
    originalPrice: 88,
    duration: '30分钟',
    description: '适合约会、面试、聚会等场合的精致编发造型，多种风格可选，让你成为人群焦点。',
    imageSeq: 'service-hair-05',
  },
  {
    id: 'hair-6',
    name: '头皮深层清洁SPA',
    category: 'hair',
    price: 98,
    originalPrice: 168,
    duration: '50分钟',
    description: '深层清洁头皮多余油脂与角质，配合专业按摩手法，放松头皮、促进血液循环。',
    imageSeq: 'service-hair-06',
  },
  {
    id: 'makeup-1',
    name: '清透日常妆',
    category: 'makeup',
    price: 58,
    originalPrice: 108,
    duration: '40分钟',
    description: '自然清透的日常妆容，突出五官优势，适合上课、逛街、日常出街。使用适合学生肤质的安全产品。',
    imageSeq: 'service-makeup-01',
  },
  {
    id: 'makeup-2',
    name: '精致约会妆',
    category: 'makeup',
    price: 88,
    originalPrice: 158,
    duration: '60分钟',
    description: '甜美温柔又带点小心机的约会妆容，重点突出眼妆与唇妆，让约会更加自信动人。',
    imageSeq: 'service-makeup-02',
  },
  {
    id: 'makeup-3',
    name: '毕业照专属妆',
    category: 'makeup',
    price: 128,
    originalPrice: 228,
    duration: '75分钟',
    description: '专为毕业照设计的持久妆容，防汗防油配方，全天不脱妆。含妆前护肤、底妆、眼妆全套服务。',
    imageSeq: 'service-makeup-03',
  },
  {
    id: 'makeup-4',
    name: '舞台演出妆',
    category: 'makeup',
    price: 98,
    originalPrice: 188,
    duration: '60分钟',
    description: '适合校园演出、社团活动的舞台妆容，色彩鲜明上镜效果好，远观近看都出彩。',
    imageSeq: 'service-makeup-04',
  },
  {
    id: 'skincare-1',
    name: '基础清洁补水',
    category: 'skincare',
    price: 68,
    originalPrice: 118,
    duration: '50分钟',
    description: '温和洁面+深层清洁面膜+补水精华导入，适合所有肤质的基础护理，让肌肤水润透亮。',
    imageSeq: 'service-skincare-01',
  },
  {
    id: 'skincare-2',
    name: '痘痘肌调理护理',
    category: 'skincare',
    price: 98,
    originalPrice: 178,
    duration: '60分钟',
    description: '针对青春期痘痘肌的专业护理，温和清痘+消炎镇静+修复面膜，有效减少痘痘反复。',
    imageSeq: 'service-skincare-02',
  },
  {
    id: 'skincare-3',
    name: '亮白淡印修复',
    category: 'skincare',
    price: 118,
    originalPrice: 208,
    duration: '65分钟',
    description: '针对痘印、色斑的美白修复护理，使用VC精华与光疗技术，淡化色素提亮肤色。',
    imageSeq: 'service-skincare-03',
  },
  {
    id: 'skincare-4',
    name: '敏感肌舒缓护理',
    category: 'skincare',
    price: 108,
    originalPrice: 188,
    duration: '60分钟',
    description: '专为敏感肌设计的温和护理，使用无添加配方产品，镇静舒缓、修复肌肤屏障。',
    imageSeq: 'service-skincare-04',
  },
  {
    id: 'nails-1',
    name: '纯色经典美甲',
    category: 'nails',
    price: 38,
    originalPrice: 68,
    duration: '30分钟',
    description: '百款纯色可选，简约不简单。优质甲油胶持久不脱落，适合日常通勤与校园生活。',
    imageSeq: 'service-nails-01',
  },
  {
    id: 'nails-2',
    name: '韩系渐变美甲',
    category: 'nails',
    price: 58,
    originalPrice: 98,
    duration: '45分钟',
    description: '温柔韩系渐变效果，从浅到深的自然过渡，精致显白，是很多女生的人气之选。',
    imageSeq: 'service-nails-02',
  },
  {
    id: 'nails-3',
    name: '创意彩绘美甲',
    category: 'nails',
    price: 78,
    originalPrice: 138,
    duration: '60分钟',
    description: '花朵、卡通、几何图案随心创作，展现你的独特个性。专业美甲师手工彩绘。',
    imageSeq: 'service-nails-03',
  },
  {
    id: 'nails-4',
    name: '足部美甲护理',
    category: 'nails',
    price: 48,
    originalPrice: 88,
    duration: '40分钟',
    description: '含足部泡浴、去角质、修甲型与上色，让双足也美美的。夏季凉鞋必备！',
    imageSeq: 'service-nails-04',
  },
  {
    id: 'package-1',
    name: '新生体验套餐',
    category: 'packages',
    price: 99,
    originalPrice: 218,
    duration: '90分钟',
    description: '剪发+日常妆+基础美甲，一站式入门体验。适合第一次来沙龙的新同学，超值首选！',
    imageSeq: 'service-package-01',
  },
  {
    id: 'package-2',
    name: '约会变身套餐',
    category: 'packages',
    price: 168,
    originalPrice: 358,
    duration: '150分钟',
    description: '韩式柔顺烫+精致约会妆+韩系渐变美甲，从头到指尖的全面升级，让你成为最闪亮的存在。',
    imageSeq: 'service-package-02',
  },
  {
    id: 'package-3',
    name: '毕业季蜕变套餐',
    category: 'packages',
    price: 258,
    originalPrice: 528,
    duration: '210分钟',
    description: '潮色渐变染+毕业照专属妆+护肤补水+创意美甲，用最美的状态迎接人生新阶段。',
    imageSeq: 'service-package-03',
  },
  {
    id: 'package-4',
    name: '闺蜜双人套餐',
    category: 'packages',
    price: 298,
    originalPrice: 598,
    duration: '180分钟',
    description: '双人剪发+双人日常妆+双人基础美甲，带上闺蜜一起变美，享受双倍快乐！',
    imageSeq: 'service-package-04',
  },
];